export const environment = {
    production: true,
    apibase: 'https://fp.sales.makalu.live/api',
    apiVersion: 'v1',
    wsbase: 'https://fp.sales.makalu.live/api',
    authorityUrl: 'https://auth.sales.makalu.live/auth',
    realm: 'sales',
    clientId: 'file-processing-ui',
    uiVersion: '1.0.20'
};
